/* eslint-disable react/jsx-pascal-case */
/* eslint-disable import/no-anonymous-default-export */
import React, { useEffect, useRef, useState } from 'react';
import { Navigate, Outlet, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Mainlayout } from '../../components/ui/ot';
import label_language from '../../components/language'
import SearchPage from './views/SearchPage'
import BookRecommend from './views/BookRecommendPage'
import PersonalRecommend from './views/PersonalRecommend'
import SchoolRecommend from './views/SchoolRecommend'
import BookReview from './views/BookReviewPage'
import DataView from './views/DataViewPage'
import News from '../../components/news/views/News';
import Chatbot from './views/Chatbot';
import RWDFunction from './views/RWDFunction';
import axios from 'axios';
import BackupRestore from './views/BackupRestore';
import New from '../../components/news/views/New'
import NewsOnlyRead from '../../components/news/views/NewsOnlyRead';
import Chatroom from './views/Chatroom';
import NoPermission from '../../components/no_permission/view/NoPermission';
import LogSelf from './views/LogSelf';
import MainRouteCarousel from '../../components/carousel/MainRoute'
import OpenTime from '../../components/app_open_time/views/OpenTime';
import EditorMessage from '../../components/editor_message/views/EditorMessage';
import NavBrandBackend from '../../theme/layout_backend2'
import Main from '../../components/utility/Main';

const Label_language = label_language.library
export default ({
    admin
}) => {
    const jwt = admin ? {
        element: <JWT />
    } : {}
    const navigate = useNavigate()
    return (
        <Routes>
            <Route path={''}
            //  {...jwt}
            >
            </Route>
            <Route path={'OpenTime'}
                element={
                    <OpenTime />
                }
            />
            <Route path={'New/:news_id'} element={<New />} />
            <Route path={'NewsOnlyRead'} element={<NewsOnlyRead />} />
            {admin && (<>
                <Route path={''} element={<JWT />}>
                    <Route path={'Log'} element={<LogSelf />} />
                    <Route path={'Chatroom'} element={<Chatroom />} />
                    <Route path={''}>
                        <Route path={''}>
                            <Route index element={<Navigate to={"/library/backstage/app/News"} />} />
                            <Route path={'Search'} element={<>
                                <SearchPage label_language={Label_language} />
                            </>} />
                            <Route path={'BookRecommend'}
                                element={
                                    <BookRecommend />
                                } />
                            <Route
                                path={'PersonalRecommend'}
                                element={
                                    <PersonalRecommend />
                                } />
                            <Route path={'SchoolRecommend'}
                                element={
                                    <SchoolRecommend />
                                } />
                            <Route path={'BookReview'}
                                element={
                                    <BookReview />
                                }
                            />
                            <Route path={'DataView'}
                                element={
                                    <DataView />
                                }
                            />
                            <Route path={'News'}
                                element={
                                    <News
                                        onClickClickToVisit={(news_id) => navigate('/app/New/' + news_id)}
                                    />
                                }
                            />
                            <Route path={'Chatbot'}
                                element={
                                    <Chatbot />
                                }
                            />
                            <Route path={'RWDFunction'}
                                element={
                                    <RWDFunction />
                                }
                            />
                            <Route path={'BackupRestore'}
                                element={
                                    <BackupRestore />
                                }
                            />
                            <Route path={'EditorMessage'}
                                element={
                                    <EditorMessage />
                                }
                            />
                            <Route path={'carousels/*'} element={<MainRouteCarousel />} />
                        </Route>
                    </Route>
                </Route>
            </>)}
            <Route path="*"
                element={<NoPermission
                    path={"/app/DataView"}
                />}>

            </Route>
        </Routes >
    );
}

const JWT = ({

}) => {
    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }

            return config;
        },
        (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
        response => {
            return response
        },
        function (error) {
            const access_token_url = '/access_token';
            const config = error.config
            if (
                error.response?.status === 401 &&
                config.url === access_token_url
            ) {
                window.location.href = ('/login')
                return Promise.reject(error)
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true
                const refreshToken = localStorage.getItem('refresh_token')
                if (!refreshToken) window.location.href = ('/login')
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken
                    })
                    .then(res => {
                        if (res?.status === 201) {
                            localStorage.setItem('access_token', res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem('access_token')}`,
                            };
                            return axios(config)
                        }
                    })
            }
            return Promise.reject(error)
        }
    )

    return <Outlet />
}